
































import { Component, Vue, Prop } from 'vue-property-decorator'
import {
  EighthComposeData,
  emptyEighthCompose
} from '@/api/eighthHeritage/eighthHeritage'
import { newGuid } from '@/configs/functions'
import EighthUnitCompose from './compose.vue'

@Component({
  components: {
    EighthUnitCompose
  }
})
export default class EighthUnitComposeList extends Vue {
  public name = 'EighthUnitComposeList'
  public modifyIndex: number = -1
  @Prop({ default: 0 })
  public unitId: number = 0

  //由父级传入
  public dataList: EighthComposeData[] = []
  public emptyForm: EighthComposeData = Object.assign({}, emptyEighthCompose)
  // dynamic component
  public $refs!: {
    composeCtrl: EighthUnitCompose
  }
  public setData(data: EighthComposeData[]) {
    this.dataList = data
  }
  public getData() {
    return this.dataList
  }
  public addData() {
    this.modifyIndex = -1
    var newData = Object.assign({}, this.emptyForm)
    const len = this.dataList.length
    let seq = 0
    if (len > 0) {
      seq = this.dataList[len - 1].SubSequence
    }
    newData.SubSequence = seq + 1
    this.showDataForm(newData)
  }
  public editData(index: number) {
    this.modifyIndex = index
    var item = this.dataList[index]
    var data = Object.assign({}, item)
    this.showDataForm(data)
  }
  public removData(index: number) {
    this.$confirm(`确定要删除吗?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        this.dataList.splice(index, 1)
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '操作已取消'
        })
      })
  }
  public updateData(data: EighthComposeData) {
    data.UnitInfoId = this.unitId
    if (this.modifyIndex >= 0) {
      this.$set(this.dataList, this.modifyIndex, data)
    } else {
      this.dataList.push(data)
    }
    this.modifyIndex = -1
  }
  //每次调用组件都生成一个guid,弹窗回传时用到
  public targetGuid: string = ''
  public showDataForm(info: EighthComposeData) {
    if (this.targetGuid == '') {
      this.targetGuid = newGuid()
    }
    window.eventBus.$emit('openEighthUnitCompose', {
      targetId: this.targetGuid,
      data: info
    })
  }
  public closeDataForm() {
    console.log('closeEighthUnitCompose')
  }
  public mounted() {
    window.eventBus.$on('submitEighthUnitCompose', (info: any) => {
      if (info.targetId == this.targetGuid) {
        this.updateData(info.data)
      }
    })
  }
  public beforeDestroy() {
    window.eventBus.$off('submitEighthUnitCompose')
  }
}
